export const environment = {
  production: false,
  serviceWorker: true,
  apiUrl: 'https://appdoc.jaca.com.py/api/v3/doctores/',
  filesBaseUrl: 'https://appdoc.jaca.com.py',
  viewer: {
    clientSideParsing: true,
    tempCacheTtlHours: 12,
    tempCacheMaxMb: 2048,
  },
};
